import styled from 'styled-components'

export const Viewer = styled.iframe`
  height: 95vh;
  width: 100%;
  border: none;
  padding-top: 55px;
`
